import { render, staticRenderFns } from "./PendingAccountNotice.vue?vue&type=template&id=90b0a7f0"
import script from "./PendingAccountNotice.vue?vue&type=script&lang=js"
export * from "./PendingAccountNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b0a7f0')) {
      api.createRecord('90b0a7f0', component.options)
    } else {
      api.reload('90b0a7f0', component.options)
    }
    module.hot.accept("./PendingAccountNotice.vue?vue&type=template&id=90b0a7f0", function () {
      api.rerender('90b0a7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_components/BillingInfo/PendingAccountNotice.vue"
export default component.exports